import {
    defaultApplicationFilters,
    getApplicationFiltersFromRequirements,
} from 'Components/campaigns/applications/ApplicationFilters';
import { PRIVILEGE } from 'constants/privilege';
import withAccessControl from 'hoc/withAccessControl';
import CampaignApplicationsList from 'pages/Campaigns/Applications/CampaignApplicationsList';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'store';

const CampaignApplications = () => {
    const { campaignId } = useParams();
    const requirements = useSelector(
        (state: RootState) => state.campaigns.items[campaignId!]?.data?.campaign?.requirements
    );

    const campaign = useSelector(
        (state: RootState) => state.campaigns.items[campaignId!]?.data?.campaign
    );

    const tabDefaultFilters = useMemo(
        () => getApplicationFiltersFromRequirements(requirements, defaultApplicationFilters),
        [requirements]
    );

    return (
        <CampaignApplicationsList
            viewBestCreative={campaign?.attach_social_post}
            bookmarked="n"
            tabDefaultFilters={tabDefaultFilters}
            resetFilters={defaultApplicationFilters}
            documentTitle="Applications - Campaign"
            emptyStateMessage="Currently there is no application in your list, try adjusting filters!"
        />
    );
};

export default withAccessControl(CampaignApplications, PRIVILEGE.CAMPAIGN.APPLICATION.INDEX);
